import Vue from 'vue';
import iView from 'iview';
import utils from '@/utils/utils';
import api from '@/api';

import 'iview/dist/styles/iview.css';
import '@/assets/css/site.less';

import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

import zh from '@/locales/zh';
import en from '@/locales/en';

import en_US from 'iview/dist/locale/en-US';
import zh_CN from 'iview/dist/locale/zh-CN';

const messages = {
  zh: Object.assign(zh, zh_CN),
  en: Object.assign(en, en_US),
};

const i18n = new VueI18n({
  locale: utils.getSystemLanguage(),
  messages,
});

Vue.use(iView, {
  i18n: (key, value) => i18n.t(key, value),
});

Vue.config.productionTip = false;

Vue.prototype.$Message.config({
  duration: 2.5,
});

function initApp(app) {
  new Vue({
    i18n,
    render: h => h(app),
  }).$mount('#app');
}

function isNoAuthPage() {
  return window.location.href.indexOf('noAuth') > -1;
}

/**
 * 初始化页面
 * @author 李彦
 * @date 2021-02-18
 * @param {Object} app 当前页面的vue实例
 * @param {Array} authorityList 页面可访问的角色列表
 * @returns {void}
 */
export default async function (app, roleList) {
  // 如uc未登录，则跳转到登录页面
  const ucStorage = utils.getUcInfo();
  if (process.env.NODE_ENV === 'production' && !ucStorage.logged) {
    return utils.turnToLoginPage(false);
  }

  if (isNoAuthPage()) {
    initApp(app);
    return;
  }

  const resp = await api.cims.isAuthorizedCims();
  if (resp.code == process.env.VUE_APP_code && resp.response.HasWebAuth) {
    utils.cookie.remove(process.env.VUE_APP_cims_cookie);
    utils.cookie.set(process.env.VUE_APP_cims_cookie, JSON.stringify(resp.response), document.domain);
    if (roleList && !utils.canAccess(roleList)) {
      utils.skipTo(`/noAuth?msg=${resp.message}`);
    } else {
      initApp(app);
    }
  } else {
    utils.skipTo(`/noAuth?msg=${resp.message}`);
  }
}
